  import OutsideSettle from "@/views/outsidesettle/OutsideSettle"
  import {nopay} from './nopay'
  import {havepay} from './havepay'
  import { inpay } from "./inpay";
  export const outsidesettle = {
    path: '/outsidesettle',
    name: 'OutsideSettle',
    component: OutsideSettle,
    children:[
      nopay,havepay,inpay
    ]
  }


// WEBPACK FOOTER //
// ./src/router/index/outsidesettle/index.js